import React, { useEffect, createContext, useState, useCallback } from "react";
import { auth } from '../firebase';

import GlocalFirestoreData from '../database/globalData';
import { jwtDecode } from 'jwt-decode';
// import { useAlert } from 'react-alert'
import BugReport from "../pages/bugReport";

import UserDb from "../database/wrappers/user";
import SubTipoDb from "../database/wrappers/subTipos";
import TipoDb from "../database/wrappers/tipos";
import PalavraChaveDb from "../database/wrappers/palavraChave";
import CausasDB from "../database/wrappers/causas";
import FortunasDB from "../database/wrappers/fortunas";
import RaridadesDB from "../database/wrappers/raridades";
import CardDB from "../database/wrappers/cards";


import imgBG from "../assets/imagens/bg_card.jpg";
import imgIgn from "../assets/imagens/ign.png";
import imgVerbus from "../assets/imagens/verbus.png";
import imgKarma from "../assets/imagens/karma.png";
import imgGnos from "../assets/imagens/gnos.png";
import imgOmna from "../assets/imagens/omna.png";
import imgDnama from "../assets/imagens/dnama.png";

import imgDominio from "../assets/imagens/dominio.png";
import imgDestino from "../assets/imagens/destino.png";
import ModalConfirm from "../componentes/modal_confirm";

export const DefaultContext = createContext({})

export default function DefaultProvider({ children }) {
	// const [user, setUser] = useState('');
	const [showBugReport, setShowBugReport] = useState(false);
	const [is_descktop, setIs_descktop] = useState(true);
	const [globalFirestoreData, setGlobalFirestoreData] = useState({});
	const [usersList, setUsersList] = useState([]);
	const [subTipos, setSubTipos] = useState([]);
	const [tipos, setTipos] = useState([]);
	const [palavraChave, setPalavraChave] = useState([]);
	const [causas, setCausas] = useState([]);
	const [fortunas, setFortunas] = useState([]);
	const [raridades, setRaridades] = useState([]);
	const [listCards, setListCards] = useState(null);
	const [showListCards, setShowListCards] = useState([]);
	const [showCardFlutuante, setShowCardFlutuante] = useState(null);
	const [filterFetch, setFilterFetch] = useState({
		name: '',
		filter: {}
	});
	const [listCardDeck, setListCardDeck] = useState([]);
	const [listCardDeckMatriz, setListCardDeckMatriz] = useState([]);
	const [quebradorDeck, setQuebradorDeck] = useState(null);
	const [deckName, setDeckName] = useState('Novo Deck');
	const [deck_tu_edit, setDeck_tu_edit] = useState(null);
	const [share_deck, setShare_deck] = useState(true);
	const [show_list_cards_deck, setShow_list_cards_deck] = useState(false);
	const [modalConfirm, setModalConfirm] = useState({
		visible: false,

		title: '',
		msm: '',
		onClose: () => { },
		onConfirm: () => { }
	})

	useEffect(() => {

		getListCards()
		let isSign = false;
		const onSubscriber = auth.onAuthStateChanged(user => {
			if (user) {
				if (isSign) return;

				// console.log('Esta logado', user);
				const onLogin = async () => {
					const token = await user.getIdToken()
					const tokenData = jwtDecode(token)
					// console.log("toeken", tokenData)
					const userDB = new UserDb()
					await userDB.get(tokenData.user_id).then(result => {
						// console.log('getUser', result)
						GlocalFirestoreData.userId = tokenData.user_id
						GlocalFirestoreData.userName = result.nome || '';
						GlocalFirestoreData.useremail = result.email || '';
						GlocalFirestoreData.role = result.role || 'user';

						const userData = {
							userId: tokenData.user_id,
							userName: result.nome || '',
							useremail: result.email || '',
							role: result.role || 'user',

						};

						setGlobalFirestoreData(prevState => ({
							...prevState,
							...userData
						}));
					}).catch(err => {
						console.log("err", err)
						auth.signOut();
					})

				}

				return onLogin();
			} else {
				console.log('Não Esta logado');

				// isSign = false;
				// setMenuSelected(null)
				// setUser(null)
			}
		})

		return onSubscriber;
	}, []);

	useEffect(() => {
		const mediaQuery = window.matchMedia('(max-width: 768px)'); // Defina aqui a largura que define um dispositivo móvel

		// Verifica se a tela é um celular ou não
		const checkDeviceType = (e) => {
			if (e.matches) {
				setIs_descktop(false); // É um celular
			} else {
				setIs_descktop(true); // É um computador
			}
		};

		// Verifica a largura da tela ao carregar a página
		checkDeviceType(mediaQuery);

		// Adiciona um listener para monitorar mudanças na largura da tela
		mediaQuery.addListener(checkDeviceType);

		// Remove o listener quando o componente é desmontado
		return () => {
			mediaQuery.removeListener(checkDeviceType);
		};
	}, []);
	useEffect(() => {
		getSubTipos();
		getUsers();
		getTipos();
		getPalavrasChave();
		getFortunas();
		getCausas();
		getRaridade();
		getListCards();
	}, [])

	// -------------filtro-----------

	const deslogar = () => {
		auth.signOut();
		GlocalFirestoreData.userId = ''
		GlocalFirestoreData.userName = '';
		GlocalFirestoreData.useremail = '';
		GlocalFirestoreData.role = '';

		const userData = {
			userId: '',
			userName: '',
			useremail: '',
			role: '',

		};

		setGlobalFirestoreData(prevState => ({
			...prevState,
			...userData
		}));
	}

	const getSubTipos = async () => {
		if (subTipos.length == 0) {
			const subTipoDB = new SubTipoDb()
			await subTipoDB.getAll().then(resultado => {
				setSubTipos(resultado)
			})
		}
	}
	const getTipos = async () => {
		if (tipos.length == 0) {
			const tipoDB = new TipoDb()
			await tipoDB.getAll().then(resultado => {
				setTipos(resultado)
			})
		}
	}
	const getPalavrasChave = async () => {
		if (palavraChave.length == 0) {
			const palavraChaveDB = new PalavraChaveDb()
			await palavraChaveDB.getAll().then(resultado => {
				setPalavraChave(resultado)
			})
		}
	}
	const getFortunas = async () => {
		if (fortunas.length == 0) {
			const fortunasDB = new FortunasDB()
			await fortunasDB.getAll().then(resultado => {
				setFortunas(resultado)
			})
		}
	}
	const getCausas = async () => {
		if (causas.length == 0) {
			const causasDB = new CausasDB()
			await causasDB.getAll().then(resultado => {
				setCausas(resultado)
			})
		}
	}
	const getRaridade = async () => {
		if (raridades.length == 0) {
			const raridadesDB = new RaridadesDB()
			await raridadesDB.getAll().then(resultado => {
				setRaridades(resultado)
			})
		}
	}
	const getListCards = async () => {
		if (listCards == null || listCards.length == 0) {
			const cardDB = new CardDB()
			await cardDB.getAll([]).then(resultado => {
				setListCards(resultado)

				if (resultado) {
					// Ordenar cartas: primeiro as que possuem causas, depois as demais1
					resultado = resultado.sort((a, b) => {
						const aCausas = a.causa && a.causa !== '' && a.causa !== null;
						const bCausas = b.causa && b.causa !== '' && b.causa !== null;

						if (aCausas && !bCausas) return -1; // a tem causa, b não tem - a vem primeiro
						if (!aCausas && bCausas) return 1;  // b tem causa, a não tem - b vem primeiro
						return 0; // ambos têm ou ambos não têm causa - manter ordem original
					});
				}
				setShowListCards(resultado)
			})
		}

	}
	const getUsers = async () => {
		if (raridades.length == 0) {
			const raridadesDB = new UserDb()
			await raridadesDB.getAll().then(resultado => {
				setUsersList(resultado)
			})
		}
	}

	function HTMLRenderer({ html }) {
		return <div dangerouslySetInnerHTML={{ __html: html }} />;
	}


	const replacesAll = (string, search, replace) => {
		return string.split(search).join(replace);
	}

	const validar_deckId_vs_userId = () => {
		if (deck_tu_edit?.user_id && globalFirestoreData?.userId == deck_tu_edit?.user_id) {
			return true
		}
		return false

	}
	const conta_cartas_lsit = (list) => {
		return list.reduce((accumulator, currentValue) => accumulator + currentValue.qtd, 0);
	}

	const resetaDeck = () => {
		setListCardDeckMatriz([])
		setListCardDeck([])
		setQuebradorDeck(null)
		setDeckName("Novo Deck")
		setShare_deck(true)
	}

	const switchModalBug = () => {
		setShowBugReport(!showBugReport)
	}

	const popUpInf = (text) => {
		return `<div style="
            position: absolute; 
            left: 50%; 
            transform: translateX(-50%);
            bottom: 100%;
            margin-bottom: 8px;
            padding: 5px;
            background: #1f2f3f; 
            color: white; 
            font-size: 12px;
            border-radius: 5px;
            border: 1px solid  #a5c5f5;
            white-space: nowrap;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
            opacity: 0;
            transition: opacity 0.3s;
            pointer-events: none;">
            ${text}
            <div style="
                content: '';
                position: absolute;
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                width: 0; 
                height: 0; 
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-top: 6px solid #a5c5f5;">
            </div>
        </div>`;
	};
	const replaceText = (text) => {
		var div_popUp = `<div style="
        display: inline-block; 
        position: relative; 
        cursor: pointer;" 
        onmouseover="this.children[1].style.opacity = '1'" 
        onmouseout="this.children[1].style.opacity = '0'">`;

		var img_quente = `<img style="width: 20px; height: 20px; display:inline; 
        -webkit-filter: drop-shadow(0px 0px 3px #FF5000); 
        filter: drop-shadow(0px 0px 3px #FF5000);" src=`;

		var img_algida = `<img style="width: 20px; height: 20px; display:inline; 
        -webkit-filter: drop-shadow(0px 0px 3px #00a0ff); 
        filter: drop-shadow(0px 0px 3px #00a0ff);" src=`;

		const img_padrao = `<img style="width: 15px; height: 15px; padding-top:2px;" src=`;


		var num_algida = '<span style="text-shadow:0px 0px 5px #00a0ff; display:inline;" >'
		var num_quente = '<span style="text-shadow:0px 0px 5px #ff0050; display:inline;" >'
		var num_neltro = '<span style="text-shadow:0px 0px 5px #ffffff; display:inline;" >'

		text = replacesAll(text, '[1]', `${div_popUp} <div>[1]</div> ${popUpInf("Durante a sua Fase de Compra.")}</div>`)
		text = replacesAll(text, '[2]', `${div_popUp} <div>[2]</div> ${popUpInf("Durante a sua Fase de Preparação.")}</div>`)
		text = replacesAll(text, '[3]', `${div_popUp} <div>[3]</div> ${popUpInf("Durante a sua Fase Principal.")}</div>`)
		text = replacesAll(text, '[4]', `${div_popUp} <div>[4]</div> ${popUpInf("Durante a sua Fase Final.")}</div>`)
		text = replacesAll(text, '[S]', `${div_popUp} <div>[S]</div> ${popUpInf("Sacrifique esta carta.")}</div>`)
		text = replacesAll(text, '[E]', `${div_popUp} <div>[E]</div> ${popUpInf("Exaure esta carta.")}</div>`)

		text = replacesAll(text, '[ign]', `${div_popUp} ${img_quente} ${imgIgn}></img> ${popUpInf("Ign")}</div>`);
		text = replacesAll(text, '[verbus]', `${div_popUp} ${img_quente} ${imgVerbus}></img> ${popUpInf("Verbus")}</div>`);
		text = replacesAll(text, '[karma]', `${div_popUp} ${img_quente} ${imgKarma}></img> ${popUpInf("Karma")}</div>`);
		text = replacesAll(text, '[gnos]', `${div_popUp} ${img_algida} ${imgGnos}></img> ${popUpInf("Gnos")}</div>`);
		text = replacesAll(text, '[dnama]', `${div_popUp} ${img_algida} ${imgDnama}></img> ${popUpInf("Dnama")}</div>`);
		text = replacesAll(text, '[omna]', `${div_popUp} ${img_algida} ${imgOmna}></img> ${popUpInf("Omna")}</div>`);
		text = replacesAll(text, '[dominio]', `${div_popUp} ${img_padrao} ${imgDominio}></img> ${popUpInf("Ponto de domínio")}</div>`);
		text = replacesAll(text, '[destino]', `${div_popUp} ${img_padrao} ${imgDestino}></img> ${popUpInf("Destino")}</div>`);


		text = replacesAll(text, '[h-destruicao]', `${div_popUp}<div>[▲]</div> ${popUpInf("Destruição")}</div>`)
		text = replacesAll(text, '[destruicao]', `${div_popUp}<div>▲</div> ${popUpInf("Destruição")}</div>`)
		text = replacesAll(text, '[h-controle]', `${div_popUp}<div>[▶]</div> ${popUpInf("Controle")}</div>`)
		text = replacesAll(text, '[controle]', `${div_popUp}<div>▶</div> ${popUpInf("Controle")}</div>`)
		text = replacesAll(text, '[h-criacao]', `${div_popUp}<div>[▼]</div> ${popUpInf("Criação")}</div>`)
		text = replacesAll(text, '[criacao]', `${div_popUp}<div>▼</div> ${popUpInf("Criação")}</div>`)
		text = replacesAll(text, '[h-alteracao]', `${div_popUp}<div>[◀]</div> ${popUpInf("Alteração")}</div>`)
		text = replacesAll(text, '[alteracao]', `${div_popUp}<div>◀</div> ${popUpInf("Alteração")}</div>`)

		text = replacesAll(text, '[1-a]', `${div_popUp} ${num_algida} 1 </span>${popUpInf("Fortuna Algida")}</div>`)
		text = replacesAll(text, '[1-q]', `${div_popUp} ${num_quente} 1 </span>${popUpInf("Fortuna Quente")}</div>`)
		text = replacesAll(text, '[1-n]', `${div_popUp} ${num_neltro} 1 </span>${popUpInf("Fortuna Neutra")}</div>`)
		text = replacesAll(text, '[2-a]', `${div_popUp} ${num_algida} 2 </span>${popUpInf("Fortunas Algidas")}</div>`)
		text = replacesAll(text, '[2-q]', `${div_popUp} ${num_quente} 2 </span>${popUpInf("Fortunas Quentes")}</div>`)
		text = replacesAll(text, '[2-n]', `${div_popUp} ${num_neltro} 2 </span>${popUpInf("Fortunas Neutras")}</div>`)
		text = replacesAll(text, '[3-a]', `${div_popUp} ${num_algida} 3 </span>${popUpInf("Fortunas Algidas")}</div>`)
		text = replacesAll(text, '[3-q]', `${div_popUp} ${num_quente} 3 </span>${popUpInf("Fortunas Quentes")}</div>`)
		text = replacesAll(text, '[3-n]', `${div_popUp} ${num_neltro} 3 </span>${popUpInf("Fortunas Neutras")}</div>`)
		text = replacesAll(text, '[x-n]', `${div_popUp} ${num_neltro} X </span>${popUpInf("Fortunas Neutras")}</div>`)
		text = replacesAll(text, '[x-q]', `${div_popUp} ${num_quente} X </span>${popUpInf("Fortunas Quentes")}</div>`)
		text = replacesAll(text, '[x-a]', `${div_popUp} ${num_algida} X </span>${popUpInf("Fortunas Algidas")}</div>`)
		text = replacesAll(text, '[y-n]', `${div_popUp} ${num_neltro} Y </span>${popUpInf("Fortunas Neutras")}</div>`)
		text = replacesAll(text, '[y-q]', `${div_popUp} ${num_quente} Y </span>${popUpInf("Fortunas Quentes")}</div>`)
		text = replacesAll(text, '[y-a]', `${div_popUp} ${num_algida} Y </span>${popUpInf("Fortunas Algidas")}</div>`)
		text = replacesAll(text, '[z-n]', `${div_popUp} ${num_neltro} Z </span>${popUpInf("Fortunas Neutras")}</div>`)
		text = replacesAll(text, '[z-q]', `${div_popUp} ${num_quente} Z </span>${popUpInf("Fortunas Quentes")}</div>`)
		text = replacesAll(text, '[z-a]', `${div_popUp} ${num_algida} Z </span>${popUpInf("Fortunas Algidas")}</div>`)



		return text
	}

	const showAlert = useCallback((title, msm, close, onConfirm) => {

		setModalConfirm({
			visible: true,
			title, msm, close, onConfirm
		})
	}, [])

	return (
		<DefaultContext.Provider value={{
			// user,
			// setUser,
			globalFirestoreData,
			deslogar,
			getSubTipos,
			subTipos,
			tipos,
			getTipos,
			getPalavrasChave,
			palavraChave,
			getFortunas,
			fortunas,
			getCausas,
			causas,
			getRaridade,
			raridades,
			getListCards,
			listCards,
			is_descktop,

			filterFetch,
			setFilterFetch,
			replaceText,
			HTMLRenderer,
			setShowListCards,
			showListCards,
			showCardFlutuante,
			setShowCardFlutuante,
			listCardDeck,
			setListCardDeck,
			listCardDeckMatriz,
			setListCardDeckMatriz,
			quebradorDeck,
			setQuebradorDeck,
			deck_tu_edit, setDeck_tu_edit,
			validar_deckId_vs_userId,
			deckName,
			setDeckName,
			conta_cartas_lsit,
			resetaDeck,
			usersList,
			share_deck, setShare_deck,
			switchModalBug,
			show_list_cards_deck,
			setShow_list_cards_deck,
			showAlert,
		}}>
			<ModalConfirm
				visible={modalConfirm.visible}
				onClose={() => {
					setModalConfirm({ ...modalConfirm, visible: false })
				}}
				onConfirm={() => { modalConfirm.onConfirm(); setModalConfirm({ ...modalConfirm, visible: false }) }}

				title={modalConfirm.title}
				msm={modalConfirm.msm}

			></ModalConfirm>

			{children}

			<BugReport visible={showBugReport}></BugReport>

		</DefaultContext.Provider>
	);
}
